import api from './api-config';

export const getAwaitingPayoutSummary = async () => {
    try {
        const response = await api.get('/payment-providers/awaiting-payout-summary', {});
        return response.data;
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
};

export const getPaymentProviderPayoutSummary = async () => {
    try {
        const response = await api.get('/payment-providers/payout-summary', {});
        return response.data;
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
};
